module.exports = __webpack_public_path__ + "static/img/title-bg.fa14ce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cash-tree/title-bg.png
// module id = XQH7
// module chunks = 215